import EntityModel          from '@/models/services/fondations/EntityModel';
import FileModel            from '@/models/services/file/FileModel';
import ApiCollection        from '@widesk-core/models/ApiCollection';
import useFile              from '@/hooks/useFile';
import { Box }              from '@chakra-ui/react';
import { Text }             from '@chakra-ui/react';
import { HiCheck }          from 'react-icons/hi';
import { HiOutlineXCircle } from 'react-icons/hi';
import Image                from '@/components/Image/Image';
import ActionsButton        from '@/components/actionsButton/ActionsButton';
import { useTranslation }   from 'react-i18next';
import { Tag }              from '@/components/ui/tag';
import { useNavigate }      from 'react-router-dom';
import useTranslations      from '@/hooks/useTranslations';
import { observer }         from 'mobx-react';

interface IEntitiesiListRowProps {
	entity:         EntityModel;
	fileCollection: ApiCollection<FileModel>;
}

const EntitiesListRow = observer((props: IEntitiesiListRowProps) => {
	const { entity, fileCollection } = props;
	const { i18n }                   = useTranslation();
	const navigate                   = useNavigate();
	const { getNavigationTranslation } = useTranslations();

	const file                       = fileCollection.find(m => m.typeSource.source.entityUrn === entity.urn) || undefined;
	const { source, sourceIsLoading } = useFile(file);

	return (
		<Box
			display="flex"
			alignItems="center"
			justifyContent="space-between"
		>
			<Box
				display="flex"
				alignItems="center"
				gap="25px"
				flex="1"
				cursor="pointer"
				onClick={() => navigate(`${getNavigationTranslation('entity', 'path')}/${entity.id}`)}
			>
				<Box
					minWidth="75px"
					maxWidth="75px"
					height="75px"
				>
					<Image
						errorSize="xl"
						borderRadius="md"
						src={source}
						sourceIsLoading={sourceIsLoading}
					/>
				</Box>
				<Box
					display="flex"
					flexDirection="column"
					gap="10px"
					paddingRight="25px"
				>
					<Box lineHeight="1"><Text className="poppins-semibold" fontSize="16px">{entity.get('corporateName')}</Text></Box>
					{entity.get('identificationNumber') && (
						<Box lineHeight="1"><Text fontSize="14px">{`Code ${entity.get('identificationNumber')}`}</Text></Box>
					)}
					<Box lineHeight="1">
						<Tag
							colorPalette={entity.entityStatus.color}
							startElement={entity.entityStatus.reference === 'ENABLED' ? <HiCheck /> : <HiOutlineXCircle />}
							size="md"
						>
							<Text textWrap="wrap">{entity.entityStatus.getLabel(i18n.language)}</Text>
						</Tag>
					</Box>
				</Box>
			</Box>
			<ActionsButton actions={[
				{
					label: 'Voir le détail',
					do: () => navigate(`${getNavigationTranslation('entity', 'path')}/${entity.id}`),
				},
			]} />
		</Box>
	);
});

export default EntitiesListRow;
